import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { graphql } from 'react-apollo';

//Query
import query from '../../../queries/fetchUser';

class Jumbotron extends Component {
	render() {
		return (
			<section className="jumbotron text-center">
		    <div className="container">
		      <h1 className="jumbotron-heading">Hola, {this.props.data.user.nombre} </h1>
		      <p className="lead text-muted">Para poder empezar ha hacer encuestas, necesitas completar tu perfil de usuario.</p>
		      <p>
		        <Link to="/dashboard/perfil/agregar/detalles" className="btn btn-primary my-2">Detalles de usuario</Link>
		      </p>
		    </div>
		  </section>					
		)
	}
}

export default graphql(query)(Jumbotron);


// WEBPACK FOOTER //
// ./src/components/User/IsValidatedUser/Jumbotron.js